import { MenuItem } from '@aando/core';

export const menu: MenuItem[] = [
  {
    level: 0,
    title: 'ID.PROFILE',
    open: false,
    selected: false,
    disabled: false,
    isVisible: true,
    children: [],
    url: '/profile',
  },
  {
    level: 0,
    title: 'ID.NOTIFICATIONS',
    open: false,
    selected: false,
    disabled: false,
    isVisible: true,
    children: [],
    url: '/notifications',
  },
  {
    level: 0,
    title: 'ID.CHATS_CENTER',
    open: false,
    selected: false,
    disabled: false,
    isVisible: true,
    children: [],
    url: '/chats-center',
  },
];
